/**
 * prevents page from jumping to the side when overflow-y:hidden has been set
 */
const scrollTrackWidth = window.innerWidth - document.body.clientWidth
document.body.style.marginRight = scrollTrackWidth.toString()+'px'